import { Observable } from "@dooboostore/core";
var DocumentUtils;
((DocumentUtils2) => {
  DocumentUtils2.querySelectorAllByAttributeName = (document, attributeName) => {
    const elements = [];
    document.querySelectorAll(`[${attributeName}]`)?.forEach((element) => {
      elements.push({ element, value: element.getAttribute(attributeName) });
    });
    return elements;
  };
  DocumentUtils2.eventObservable = (document, type, options) => {
    return new Observable((subscriber) => {
      const handler = (event) => subscriber.next(event);
      window.addEventListener(type, handler, options);
      return () => {
        window.removeEventListener(type, handler, options);
      };
    });
  };
})(DocumentUtils || (DocumentUtils = {}));
export {
  DocumentUtils
};
//# sourceMappingURL=DocumentUtils.js.map
